export default __webpack_public_path__ + "static/media/lights-sign.90a3fb54.svg";